import { createFileRoute } from '@tanstack/react-router'
import { ScPlannerPage } from '@/features/support-coordination/planner'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/planner',
)({
  component: ScPlannerPage,
})
